import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

/* Route guard for the three portals (/dashboard, /employer, /employee).
   Sends anyone who isn't signed in, or is signed in with the wrong role,
   back to the landing page. This is a UI convenience only, not a security
   boundary — every real check still happens server-side (every accounts
   view re-checks request.user, BACKEND_API_FLOW.md §2). */
function RequireRole({ allow }) {
  const { status, user } = useAuth();

  if (status === 'loading') {
    return (
      <div className="auth-shell">
        <div className="auth-meta">Checking your session…</div>
      </div>
    );
  }

  if (status !== 'authenticated' || !allow.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

export default RequireRole;
